var mockApis = [
// '/v2/performance',
//  '/groupPurchase',
//  '/order/detail/v2',
//  '/orders',
//  '/performance/preselectDe',
//  '/calendar',
//  '/calendar/tag',
'/project/detail', '/project/shows/dateCard', '/project/hotComment', 'derivation/relationlLis'];
export default mockApis;